import './paedml-card.tag'
import './paedml-modal-delete.tag'
import './paedml-icon.tag'
import './paedml-icon-modal.tag'
import './mdm/paedml-modal-school-mdm.tag'
import './mdm/paedml-modal-settings-mdm.tag'
import './mdm/paedml-modal-activate-mdm.tag'
import './components/paedml-modal-regenerate-sshkey.tag'
import './mdm/paedml-modal-config-mdm.tag'
import './mdm/paedml-modal-update-mdm.tag'
import './mdm/paedml-modal-status-mdm.tag'
import './mdm/paedml-modal-mdm-log.tag'
import './mdm/paedml-modal-mdm-ldap.tag'
import './mdm/paedml-modal-regenerate-apitoken.tag'
import './mdm/paedml-modal-school-reset-status.tag'

<paedml-card-mdm>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings}>

    <virtual if={parent.variant === 'settings' && isPermitted('settings')}>
      <paedml-icon-modal icon="fas-cogs" target="#{prefix}-settings-modal" title="MDM Grundeinstellungen" />
      <paedml-modal-settings-mdm prefix="{prefix}-settings" 
        heading="{config.contentTitle}: MDM Grundeinstellungen" opname="Änderung speichern" api={parent.api} variant={parent.variant}/>
    </virtual>

    <virtual if={parent.variant === 'settings' && isPermitted('ssh')}>
      <paedml-icon-modal icon="passwort-bearbeiten" target="#{prefix}-regenerate-sshkey-modal" title="SSH Schlüssel neu erstellen" />
      <paedml-modal-regenerate-sshkey prefix="{prefix}-regenerate-sshkey"
        heading="{config.contentTitle}: SSH-Schlüssel erstellen" opname="SSH-Schlüssel neu erstellen" api={parent.api}
        patient="MDM"
      />
    </virtual>
    
    <virtual if={parent.variant === 'settings' && isPermitted('update')}>
      <paedml-icon-modal icon="passwort-bearbeiten-g" target="#{prefix}-regenerate-apitoken-modal" title="API token neu erstellen" />
      <paedml-modal-regenerate-apitoken prefix="{prefix}-regenerate-apitoken"
        heading="{config.contentTitle}: API-Token erstellen" opname=" API-Token neu erstellen" api={parent.api}
      />
    </virtual>

    <virtual if={parent.variant === 'settings' && isPermitted('update') && parent.canConfigure(this)}>
      <paedml-icon-modal icon="geraet-starten" target="#{prefix}-config-mdm-modal" title="MDM-Server Starten" />
      <paedml-modal-config-mdm prefix="{prefix}-config-mdm" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM-Server Konfiguration" opname="OK" api={parent.api}
      />
    </virtual>
    
    <virtual if={parent.variant === 'settings' && isPermitted('update') && parent.canUpdate(this)}>
      <paedml-icon-modal icon="aktualisieren" target="#{prefix}-update-mdm-modal" title="MDM-Server Update" />
      <paedml-modal-update-mdm prefix="{prefix}-update-mdm" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM-Server Update" opname="OK" api={parent.api}
      />
    </virtual>

    <virtual if={isPermitted('status')}>
      <paedml-icon-modal icon="fas-satellite-dish" target="#{prefix}-status-mdm-modal" title="MDM Status anzeigen" />
      <paedml-modal-status-mdm prefix="{prefix}-status-mdm" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM Status anzeigen" opname="OK" api={parent.api}
      />
    
    </virtual>

    <!--  <virtual if={parent.variant === 'settings' && isPermitted('log')}>
      <paedml-icon-modal icon="fas-file-download" target="#{prefix}-mdm-log-modal" title="MDM Log-Datei herunterladen" />
      <paedml-modal-mdm-log prefix="{prefix}-mdm-log" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM Log-Datei herunterladen" opname="OK" api={parent.api}
      />
    </virtual>  -->
    
    <virtual if={parent.variant === 'settings' && isPermitted('update')}>
      <paedml-icon-modal icon="fas-circle-nodes" target="#{prefix}-mdm-ldap-modal" title="MDM LDAP-Verbindung zurücksetzen" />
      <paedml-modal-mdm-ldap prefix="{prefix}-mdm-ldap" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM LDAP-Verbindung zurücksetzen" opname="OK" api={parent.api}
      />
    </virtual>

    <virtual if={parent.variant === 'schooltype' && selectedExactlyOne() && isPermitted('settings')}>
      <paedml-icon-modal icon="fas-wrench" target="#{prefix}-configure-modal" title="MDM-Schuleinstellungen" />
      <paedml-modal-school-mdm prefix="{prefix}-configure" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: MDM-Schuleinstellungen" opname="Änderung speichern" api={parent.api} variant={parent.variant}/>
    </virtual>

    <virtual if={parent.variant === 'schooltype' && selectedExactlyOne() && isPermitted('settings') && parent.canReset(getSelectedRows)}>
      <paedml-icon-modal icon="fas-redo-alt" target="#{prefix}-reset-modal" title="Status zurücksetzen" />
      <paedml-modal-school-reset-status prefix="{prefix}-reset" edit={true} selectedrowsfunc={getSelectedRows} idcol="0" idtextcol="1"
        heading="{config.contentTitle}: Status zurücksetzen" opname="Status zurücksetzen" api={parent.api} variant={parent.variant}/>
    </virtual>

    <virtual if={parent.variant === 'schooltype' && isPermitted('activate') && selectedOneOrMore()}>
      <paedml-icon-modal icon="fas-toggle-on" target="#{prefix}-activate-mdm-modal" title="MDM aktivieren / deaktivieren" />
      <paedml-modal-activate-mdm prefix="{prefix}-activate-mdm" selectedrowsfunc={getSelectedRows}
        variant={config.custom.variant}
        patient="{{singular: 'MDM', plural: 'MDM', for: 'für'}}"
        heading="{config.contentTitle}: MDM aktivieren / deaktivieren" opname="Änderung speichern" api={parent.api}
      />
    </virtual>

  </paedml-card>
  <script>
    import API from '../api'

    this.opname = this.opts.opname
    this.variant = opts.config.custom.variant
    this.api = API.mdm  

    this.canConfigure = (ctx) => {
      return true
    }

    this.canUpdate = (ctx) => {
      return true
    }

    this.canReset = (getSelectedRows) => {
      const selected = getSelectedRows()
      return selected[0][4] === 3
    }
    
    </script>
</paedml-card-mdm>
